import store from 'public/store'
/**
 *
 * @desc 在路由守卫的beforeResolve中增加菜单信息。防止代码在后台运行时，取错菜单信息。
 * @export
 * @param {*} to
 */
export function setMenuIdToComponent (to) {
  const __ERP_MENU_KEY__ = '__ERP_MENU_KEY__'
  let menu = store.getters.menus[to.meta.tag]
  // 不存在的菜单不上报
  if (menu && to.matched && to.matched[1] && to.matched[1].components && to.matched[1].components.default) {
    to.matched[1].components.default[__ERP_MENU_KEY__] = {
      menu
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/router/tools.js